import { useEffect, useMemo, useState } from "react"
import { itemSupplierService } from "src/services/reservation/itemSupplier/itemSupplier.service"
import { ItemsFilter, PostFilterFormItems } from "./ItemsFilter"
import { Box, Grid, Skeleton, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField } from "@mui/material"
import { useTranslate } from "react-admin"
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { parseDateFormat } from "src/helper/parseDateFormat"
import { parseDateOnlyFormat } from "src/helper/parseDateOnlyFormat"
import { numberFormatterWithDecimalAndThousand } from "src/helper/numberFormatterWithDecimalAndThousand"
import { StatusTableCell } from "../../sales/reservation/helper/StatusTableCell"
import { InboxOutlined } from '@mui/icons-material'

const ItemRow = ({
    item,
    i,
    setSelectedItems,
    setTotalAmount,
    selectedItems,
    isShow,
    originallySelectedItems,
    isCreditNote,
    selectedAllItems,
    hiddenColumns = []
}) =>{
    const [valueAmount, setValueAmount] = useState(0)

    const isSelected = originallySelectedItems?.map(select=>select.id).includes(item.id) ?? false
    
    useEffect(()=>{
        if(selectedAllItems){
            setValueAmount(item.amount_pending)
        }
    },[selectedAllItems])

    const incrementTotalBy = (value) =>{
        setTotalAmount(totalAmount =>isCreditNote ?(totalAmount - value) :(totalAmount + value))
        setSelectedItems(selectedItems=>selectedItems.map(selected=>selected.id === item.id ? {...selected,amount_pending:isCreditNote?(Number(value) - valueAmount):(Number(value) + valueAmount)} :selected))
    }

    const decrementTotalby = (value) =>{
        setTotalAmount(totalAmount =>isCreditNote ? (totalAmount + value):(totalAmount - value))
        setSelectedItems(selectedItems=>selectedItems?.map(selected=>selected.id === item.id ? {...selected,amount_pending:isCreditNote? (-Number(value) - valueAmount):(-Number(value) + valueAmount)} :selected))
    }

    const addItem = () =>{
        let auxSelectedItems = [...selectedItems]
        auxSelectedItems.push(item)
        setSelectedItems(auxSelectedItems)
        setTotalAmount(totalAmount =>(totalAmount + valueAmount))
    }

    const removeItem = () => {
        if (!isSelected) {
            setSelectedItems(auxSelectedItems => auxSelectedItems.filter(selected=>selected.id !== item.id))
            setTotalAmount(totalAmount => (totalAmount - valueAmount))
        }
    }

    useEffect(()=>{
        setValueAmount(
            isCreditNote ? 
            -(Number(item.amount || item.amount_pending)):
            (Number(item.amount || item.amount_pending)) ?? 0
        )
    },[isCreditNote])

    return(
        <TableRow key={i}>
            {!isShow && (
                <TableCell>
                    {(selectedItems?.some(selected => selected.id === item.id) || isSelected) ?
                        <CheckBoxIcon
                            onClick={removeItem}
                            color={isSelected ? 'disabled' : ''}
                            style={{cursor: isSelected ? 'default' : 'pointer'}}
                        />
                    :
                        <CheckBoxOutlineBlankIcon onClick={addItem} style={{ cursor: 'pointer' }}/>
                    }
                </TableCell>

            )}
            <TableCell>
                {item.detail?.name}
            </TableCell>
            <TableCell>
                {item.code || item.detail?.code}
            </TableCell>
            <TableCell>
                {item.number}
            </TableCell>
            <StatusTableCell data={item.status}/>
            <TableCell>
               {item?.currency_relation?.short_name} {numberFormatterWithDecimalAndThousand(item?.amount_total)}
            </TableCell>
            {!hiddenColumns.includes('amount_paid') && (
            <TableCell>
                <TextField
                    type='number'
                    step="any"
                    defaultValue={isCreditNote ? -(item.amount || item.amount_pending):(item.amount || item.amount_pending)}
                    size='small'
                    value={(isCreditNote && valueAmount > 0 )? -valueAmount: valueAmount}
                    disabled={!selectedItems?.map(selected=>selected.id).includes(item.id) || isShow || isSelected}
                    onChange={e=>{
                        let new_value = e.target.value
                        if(isCreditNote){
                            if(new_value > 0){
                                new_value = -new_value
                            }
                        }
                        if(e.target.value > valueAmount){
                            incrementTotalBy(isCreditNote ? -(new_value - valueAmount) : (new_value - valueAmount))
                        } else {
                            decrementTotalby(isCreditNote ? -(valueAmount - new_value):(valueAmount - new_value))
                        }
                        setValueAmount((isCreditNote && Number(new_value) > 0 )? -Number(new_value): Number(new_value))
                    }}
                />
            </TableCell>
            )}
            {!hiddenColumns.includes('amount_pending') && (
            <TableCell>
                {item?.currency_relation?.short_name} {numberFormatterWithDecimalAndThousand((isCreditNote ? -item.amount_pending : item.amount_pending)?? 0)}
            </TableCell>
            )}
            <TableCell>
                {parseDateFormat(item.created_at)}
            </TableCell>
            <TableCell>
                {parseDateOnlyFormat(item.due_date)}
            </TableCell>
        </TableRow>
    )
}

export const ItemsTable = ({
    title = 'Items Totales',
    supplierId,
    currencyId,
    selectedItems = [],
    setSelectedItems = null,
    editData = null,
    enableFilters = true,
    isShow = false,
    originallySelectedItems,
    isCreditNote = false,
    isPaymentOrder = false,
    hideTitle = false,
    hideIfNotSupplier = false,
    messageIfNoSupplier = '',
    resetOnChangeSupplier = false,
    setAllItems,
    hiddenColumns = []
}) =>{
    const translate = useTranslate()
    const [supplierItems, setSupplierItems] = useState([])
    const [loadingSupplierItems, setLoadingSupplierItems] = useState(false)
    const [totalRows, setTotalRows] = useState(0)
    const [totalAmount, setTotalAmount] = useState(0)
    const [totalAmountPending, setTotalAmountPending] = useState(0)
    const [totalAmountTotal, setTotalAmountTotal] = useState(0)
    const [selectedAllItems, setSelectedAllItems] = useState(null)
    const [paginationItemData, setPaginationItemData] = useState({ page: 0, rowsPerPage: 10, realPage:0 })
    const [filterValues, setFilterValues] = useState({})
    const [displayedFilters, setFilters] = useState({})

    const listFilters = [
        { source: 'item__date_in', name: 'ra.field.start_date' },
        { source: 'due_date', name: 'ra.field.due_date' },
        { source: 'code__in', name: 'ra.field.code' },
        { source: 'created_at', name: 'ra.field.created_at' },
        { source: 'reservation__number__in', name: 'ra.field.reserve' },
        { source: 'billing_ilike__in', name: 'ra.field.invoice' },
        { source: 'item__date_out', name: 'ra.field.date_out' },
    ]

    const itemsTitles = ['name','code', 'reserve', 'payment_status', 'total_amount', 'amount_paid', 'amount_pending', 'created_at', 'due_date']

    const cleanFilters = useMemo(() => {
        return Object.fromEntries(
            Object.entries(filterValues).filter(([key, value]) => 
                value !== undefined && value !== null && value !== ''
            )
        );
    }, [filterValues]);

    const items = useMemo(() => (
        editData ? (
            paginationItemData.rowsPerPage > 0
                ? supplierItems.slice(
                    paginationItemData.page * paginationItemData.rowsPerPage,
                    paginationItemData.page * paginationItemData.rowsPerPage + paginationItemData.rowsPerPage
                )
                : supplierItems
        ) : supplierItems
    ), [editData, paginationItemData, supplierItems])

    const getSupplierItems = async () => {
        if (editData) {
            setSupplierItems(editData)
            setTotalRows(editData.length)
        } else {
            if (!hideIfNotSupplier || supplierId) {
                setLoadingSupplierItems(true)
                if (isPaymentOrder){ // Logica especial para aplicarle filtro de estados
                    await itemSupplierService.getItemsSupplier({...filterValues, status__in:"UNPAID,PARTIALLY_PAID,PARTIALLY_APPLIED,AVAILABLE", supplier_id:supplierId, currency_id:currencyId, limit:paginationItemData.rowsPerPage, skip:paginationItemData.realPage}).then(res=>{
                        setSupplierItems(res.data)
                        setTotalRows(Number(res.total)) 
                    }).finally(()=>{
                        setLoadingSupplierItems(false)
                    })
                } else {
                    await itemSupplierService.getItemsSupplier({...filterValues, supplier_id:supplierId, currency_id:currencyId, limit:paginationItemData.rowsPerPage, skip:paginationItemData.realPage}).then(res=>{
                        setSupplierItems(res.data)
                        setTotalRows(Number(res.total))
                        setAllItems?.(res.data)
                    }).finally(()=>{
                        setLoadingSupplierItems(false)
                    })
                }
            }
        }
    }

    const calculateTotal = (itemsForTotals) =>{
        let count = 0
        for(let selected of itemsForTotals){
            count = count + (selected.amount || selected.amount_pending)
        }
        /* if(count > 0) */
            setTotalAmount(isCreditNote ? -count:count)
    }

    // Calculos para subtotales
    const calculateAmountPendingTotal = (items) => {
        let total = 0

        for (const item of items) {
            total += Number(item.amount_pending || 0)
        }

        setTotalAmountPending(isCreditNote ? -total : total)
    }

    const calculateAmountTotalTotal = (items) => {
        let total = 0

        for (const item of items) {
            total += Number(item.amount_total || 0)
        }

        setTotalAmountTotal(isCreditNote ? -total : total)
    }

    useEffect(() => {
        if (supplierItems?.length) {
            calculateAmountTotalTotal(supplierItems)
            calculateAmountPendingTotal(supplierItems)
        } else {
            setTotalAmountTotal(0)
            setTotalAmountPending(0)
        }
    }, [supplierItems, isCreditNote])
    // Fin calculos para subtotales

    useEffect(() => {
        if (resetOnChangeSupplier) {
            setSelectedItems([])
        }
    }, [supplierId])

    useEffect(()=>{
        getSupplierItems()
    }, [supplierId, currencyId, JSON.stringify(cleanFilters), paginationItemData, editData, isCreditNote])

    useEffect(()=>{
        if(editData){
            calculateTotal(selectedItems)
        }else {
            let itemsForTotals = supplierItems?.filter(item=>selectedItems?.map(selected=>selected.id).includes(item.id))
            calculateTotal(itemsForTotals)
        }
    }, [supplierItems, selectedAllItems])

    const onPageItemChange = (number) => {
        const paginationItemDataAux = { ...paginationItemData }
        paginationItemDataAux.page = number
        paginationItemDataAux.realPage = number * paginationItemDataAux.rowsPerPage
        setPaginationItemData(paginationItemDataAux)
    }

    const onRowsPerPageItemChange = (e) => {
        const paginationItemDataAux = { ...paginationItemData }
        paginationItemDataAux.rowsPerPage = parseInt(e.target.value, 10)
        paginationItemDataAux.page = 0
        paginationItemDataAux.realPage = 0
        setPaginationItemData(paginationItemDataAux)
    }

    return(
        <>
            {hideIfNotSupplier && !supplierId ? (
                <Box
                    style={{
                        height: 150,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '16px',
                        fontSize: 18,
                        color: '#9a9a9a'
                    }}
                >
                    <InboxOutlined fontSize='large' />
                    {messageIfNoSupplier && <b>{messageIfNoSupplier}</b>}
                </Box>
            ) : (
                <>
                    {!hideTitle && (
                        <label style={{fontWeight:'bold'}}>
                            {title}
                        </label>
                    )}

                    {enableFilters && (
                        <Grid container rowSpacing={3}>
                            <Grid item xs={12} textAlign='end'>
                                <ItemsFilter
                                    displayedFilters={displayedFilters}
                                    setFilters={setFilters}
                                    listFilters={listFilters}
                                    setFilterValues={setFilterValues}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <PostFilterFormItems 
                                    displayedFilters={displayedFilters} 
                                    filterValues={filterValues} 
                                    setFilters={setFilters}
                                    setFilterValues={setFilterValues}
                                />
                            </Grid>
                        </Grid>
                    )}

                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {!isShow && (
                                        <TableCell>
                                            {selectedAllItems ? 
                                                <CheckBoxIcon
                                                    onClick = {()=>{
                                                        if(!isShow){
                                                            setSelectedItems(originallySelectedItems ?? []); setSelectedAllItems(false)
                                                        }
                                                    }}
                                                    style={{cursor:isShow?'default':'pointer'}}
                                                    color={(isShow) ? 'disabled' : ''}
                                                />
                                            :
                                                <CheckBoxOutlineBlankIcon 
                                                    onClick = {()=>{
                                                        if(!isShow){
                                                            const selectedList = supplierItems
                                                            const resultado = [...new Set([...(originallySelectedItems ?? []), ...selectedList])];
                                                            setSelectedItems(resultado); setSelectedAllItems(true)}
                                                    }}
                                                    style={{cursor:isShow?'default':'pointer'}}
                                                    color={(isShow) ? 'disabled' : ''}
                                                />
                                            }
                                        </TableCell>
                                    )}
                                    {itemsTitles.filter((title) => !hiddenColumns.includes(title)).map((title, i)=>(
                                        <TableCell key={i}>
                                            {translate(`ra.field.${title}`)}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    loadingSupplierItems ? 
                                        <TableRow>
                                            {Array.from({ length: 9}).map((_,i)=>(
                                                <TableCell key={i}>
                                                    <Skeleton variant='rectangular' height={40} width={'100%'}/>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    :
                                    (
                                        items.map((item, i)=>(
                                            <ItemRow 
                                                key={i} 
                                                item={item} 
                                                i={i} 
                                                setSelectedItems={setSelectedItems} 
                                                setTotalAmount={setTotalAmount} 
                                                selectedItems={selectedItems} 
                                                isShow={isShow} 
                                                originallySelectedItems={originallySelectedItems} 
                                                isCreditNote={isCreditNote}
                                                selectedAllItems={selectedAllItems}
                                                hiddenColumns={hiddenColumns}
                                            />
                                        ))
                                    )
                                }
                                <TableRow>
                                    {!isShow && <TableCell/>}
                                    <TableCell/>
                                    <TableCell/>
                                    <TableCell/>
                                    <TableCell>
                                        {translate('ra.field.total')}
                                    </TableCell>
                                    <TableCell>
                                        {items?.[0]?.currency_relation?.short_name} {numberFormatterWithDecimalAndThousand(totalAmountTotal)}
                                    </TableCell>
                                    {!hiddenColumns.includes('amount_paid') && (
                                    <TableCell>
                                        {items?.[0]?.currency_relation?.short_name} {numberFormatterWithDecimalAndThousand(totalAmount)}
                                    </TableCell>
                                    )}
                                    {!hiddenColumns.includes('amount_pending') && (
                                    <TableCell>
                                        {items?.[0]?.currency_relation?.short_name} {numberFormatterWithDecimalAndThousand(totalAmountPending)}
                                    </TableCell>
                                    )}
                                    <TableCell/>
                                    <TableCell/>
                                </TableRow>
                            </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                            rowsPerPage={paginationItemData.rowsPerPage}
                                            page={paginationItemData.page}
                                            count={totalRows}
                                            onPageChange={(e, number) => onPageItemChange(number)}
                                            onRowsPerPageChange={(e) => onRowsPerPageItemChange(e)}
                                            labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                                            labelDisplayedRows={({ from, to, count }) =>
                                                `${from}–${to} ${translate('ra.navigation.of')} ${count}`
                                            }
                                        />
                                    </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </>
            )}
        </>
    )
}